// Vue directive to automatically convert email input to lowercase
const lowercaseEmail = {
  mounted(el, _binding) {
    // Find the actual input element if it's wrapped
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input[type="email"]') || el.querySelector('input');

    if (input) {
      // Handler to convert to lowercase on input
      const handleInput = (event) => {
        const target = event.target;
        const cursorPosition = target.selectionStart;
        const originalValue = target.value;
        const lowercaseValue = originalValue.toLowerCase();

        // Only update if the value actually changed to avoid unnecessary DOM updates
        if (originalValue !== lowercaseValue) {
          target.value = lowercaseValue;

          // Trigger input event to update v-model
          const inputEvent = new Event('input', { bubbles: true });
          target.dispatchEvent(inputEvent);

          // Restore cursor position
          target.setSelectionRange(cursorPosition, cursorPosition);
        }
      };

      // Store the handler on the element for cleanup
      input._lowercaseEmailHandler = handleInput;

      // Listen to input events
      input.addEventListener('input', handleInput);

      // Also handle paste events
      const handlePaste = (_event) => {
        setTimeout(() => {
          const inputEvent = new Event('input', { bubbles: true });
          input.dispatchEvent(inputEvent);
        }, 0);
      };

      input._lowercaseEmailPasteHandler = handlePaste;
      input.addEventListener('paste', handlePaste);
    }
  },

  unmounted(el) {
    // Clean up event listeners
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input[type="email"]') || el.querySelector('input');

    if (input) {
      if (input._lowercaseEmailHandler) {
        input.removeEventListener('input', input._lowercaseEmailHandler);
        delete input._lowercaseEmailHandler;
      }

      if (input._lowercaseEmailPasteHandler) {
        input.removeEventListener('paste', input._lowercaseEmailPasteHandler);
        delete input._lowercaseEmailPasteHandler;
      }
    }
  },
};

export default lowercaseEmail;
